module.exports = __webpack_public_path__ + "img/pos.a2ddcb8c.svg";